import { render, staticRenderFns } from "./evaluar_laborante.vue?vue&type=template&id=22393250"
import script from "./evaluar_laborante.vue?vue&type=script&lang=js"
export * from "./evaluar_laborante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports